import React from 'react';
import { Panel } from '../ui/Panel';
import { Meter } from '../ui/Meter';
import { Badge } from '../ui/Badge';
import { attendance } from '../../data/academics';
import { percent } from '../../utils/format';
export function AttendancePanel() {
  const totalHeld = attendance.reduce((sum, record) => sum + record.held, 0);
  const totalAttended = attendance.reduce((sum, record) => sum + record.attended, 0);
  const overall = percent(totalAttended, totalHeld);
  return <div className="grid gap-6 lg:grid-cols-3" data-id="element-267" data-mp="28tbntu1x8d5u">
      <div className="lg:col-span-2" data-id="element-268" data-mp="23vjseq22i8ww">
        <Panel title="Attendance by course" bodyClassName="p-0" data-id="element-269" data-mp="23yo7iih2mp2c">
          <ul className="divide-y divide-line" data-id="element-270" data-mp="1yy9wcrk6az03">
            {attendance.map(record => {
            const rate = percent(record.attended, record.held);
            const below = rate < record.requirement;
            return <li key={record.courseCode} className="px-5 py-4" data-id="element-271" data-mp="3t96var9ajcfb">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-272" data-mp="3pafuoa5m9cng">
                    <p className="cz-num text-sm font-semibold text-ink" data-id="element-273" data-mp="24c8oq2p8eah3">{record.courseCode}</p>
                    {below ? <Badge tone="warn" data-id="element-274" data-mp="29d66wfa8r4il">Below requirement</Badge> : <Badge tone="ok" data-id="element-275" data-mp="1vd53ot6i7kzy">Eligible</Badge>}
                    <span className="cz-num ml-auto text-sm font-semibold text-ink" data-id="element-276" data-mp="1zcnegw4m2fp2">{rate}%</span>
                  </div>
                  <div className="mt-2.5" data-id="element-277" data-mp="2n4aweojwagf7">
                    <Meter value={rate} tone={below ? 'warn' : 'ok'} height="thin" data-id="element-278" data-mp="2n5ccj7frpt3s" />
                  </div>
                  <p className="cz-num mt-1.5 text-[12px] text-ink-muted" data-id="element-279" data-mp="2eao8fklxihgk">
                    {record.attended} of {record.held} classes · {record.requirement}% required
                  </p>
                </li>;
          })}
          </ul>
        </Panel>
      </div>
      <Panel title="This semester" data-id="element-280" data-mp="36011ikn4jsxb">
        <p className="cz-num text-3xl font-semibold tracking-tight text-ink" data-id="element-281" data-mp="3at3uornzp0cz">{overall}%</p>
        <p className="mt-1 text-[13px] text-ink-muted" data-id="element-282" data-mp="3kp2qrltdlkrb">Overall attendance across all courses</p>
        <dl className="mt-4 space-y-2 border-t border-line pt-4" data-id="element-283" data-mp="3gn8udpq7r2wy">
          <div className="flex justify-between text-[13px]" data-id="element-284" data-mp="3gkuy5djsrknt">
            <dt className="text-ink-muted" data-id="element-285" data-mp="3bmtdwpamxfar">Classes held</dt>
            <dd className="cz-num font-medium text-ink" data-id="element-286" data-mp="36orw07oy3m0v">{totalHeld}</dd>
          </div>
          <div className="flex justify-between text-[13px]" data-id="element-287" data-mp="36r5p4b02eo5s">
            <dt className="text-ink-muted" data-id="element-288" data-mp="31r9n2haxh6sv">Classes attended</dt>
            <dd className="cz-num font-medium text-ink" data-id="element-289" data-mp="2wygh5q3q3sf7">{totalAttended}</dd>
          </div>
          <div className="flex justify-between text-[13px]" data-id="element-290" data-mp="2sx4zq7v06di3">
            <dt className="text-ink-muted" data-id="element-291" data-mp="2svaf6unn8nej">Missed</dt>
            <dd className="cz-num font-medium text-ink" data-id="element-292" data-mp="2nz382yjih5v0">{totalHeld - totalAttended}</dd>
          </div>
        </dl>
        <p className="mt-4 text-[12px] leading-5 text-ink-subtle" data-id="element-293" data-mp="2ixvz4w5mu0mr">
          Records you keep yourself. When your university enables full integration, official
          attendance replaces these figures.
        </p>
      </Panel>
    </div>;
}